// import { useContext } from "react";
// import { PaymentContext } from "context/PaymentContext";

export default function useFeatureList() {
  // const { enabledFeatures = {} } = useContext(PaymentContext);

  return [
    {
      media: { icon: "search", color: "info", className: "fs-4" },
      title: "TopX & SearchX",
      description:
        "Optimize ticket workflows with AI-powered ingestion and intelligent search capabilities.",
      // enabled: enabledFeatures["TopX & SearchX"] ?? false,
    },
    {
      media: { icon: "comment", color: "success", className: "fs-4" },
      title: "BotX",
      description:
        "AI-driven bot that intelligently processes knowledge bases, files, and links to deliver precise, context-aware responses.",
      // enabled: enabledFeatures["BotX"] ?? false,
    },
    {
      media: { icon: "envelope", color: "primary", className: "fs-4" },
      title: "EmailX",
      description:
        "Streamline professional email communication with automated drafting tools.",
      // enabled: enabledFeatures["EmailX"] ?? false,
    },
    {
      media: { icon: "poll", color: "warning", className: "fs-4" },
      title: "XSurvey",
      description:
        "Leverage survey tools to gather actionable customer feedback and insights.",
      // enabled: enabledFeatures["XSurvey"] ?? false,
    },
    {
      media: { icon: "chart-line", color: "danger", className: "fs-4" },
      title: "XAnalytics",
      description:
        "Drive decisions with comprehensive analytics on performance and trends.",
      // enabled: enabledFeatures["XAnalytics"] ?? false,
    },
    {
      media: { icon: "check-circle", color: "secondary", className: "fs-4" },
      title: "XQA",
      description:
        "Maintain support quality with tools to evaluate and ensure agent excellence.",
      // enabled: enabledFeatures["XQA"] ?? false,
    },
  ];
}
